// extracted by mini-css-extract-plugin
export default {"backdrop":"AuthModal_backdrop__b7vGr","modal":"AuthModal_modal__R-aSS","closeButton":"AuthModal_closeButton__CwkQo","closeIcon":"AuthModal_closeIcon__a4Wk-"};